import { colors } from '&assets/constants/colors';
import { device } from '&assets/constants/responsiveness';
import styled from 'styled-components';

export const ThemeDetailsWrapper = styled.div`
	padding-top: 100px;
	.loading-center {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 20px;
		.MuiCircularProgress-colorInherit {
			color: ${colors.primary};
		}
	}
	.content {
		padding: 50px 0px;
		.header {
			display: flex;
			.theme-img {
				width: 50%;
				flex: 1;
				object-fit: contain;
			}
			.header-titles {
				flex: 1;
				margin-left: 20px;
				padding: 10px;
				.title {
					font-family: 'Signifier-Regular';
					font-size: 3.25rem;
					line-height: 2.5rem;
					letter-spacing: -0.03em;
					color: ${colors.primary};
					margin-top: 0;
				}
				.sub-title {
					font-size: 1.1rem;
					line-height: 1.5rem;
					color: ${colors.textDark};
				}
				.additional {
					display: flex;
					flex-wrap: wrap;
					align-items: center;
					justify-content: space-between;
					.additional-item {
						color: ${colors.textDark};
					}
				}
			}
		}
		.challenge-description {
			margin-top: 40px;
			font-size: 1.25rem;
			line-height: 1.5rem;
			color: ${colors.textDark};
		}
		.theme-description {
			font-size: 1.25rem;
			line-height: 1.5rem;
			color: ${colors.textDark};
		}

		.apply-now {
			background-color: white;
			border: 1px solid ${colors.primary};
			cursor: pointer;
			align-self: center;
			border-radius: 50px;
			margin: auto;
			margin-top: 40px;
		}
		.apply-now-title {
			color: ${colors.primary};
		}
	}

	@media ${device.tablet} {
		.content {
			padding: 20px;
			.header {
				flex-direction: column-reverse;
				.theme-img {
					width: 100%;
					flex: 1;
					object-fit: contain;
					margin-top: 30px;
				}
				.header-titles {
					flex: 1;
					margin-left: 0;
					padding: 0;
					.title {
						font-size: 2.5rem;
					}
					.sub-title {
						font-size: 1rem;
						line-height: 1.5rem;
						color: ${colors.textDark};
					}
				}
			}
		}
	}

	@media ${device.mobile} {
		.content {
			padding: 20px;
			.header {
				flex-direction: column-reverse;
				.theme-img {
					width: 100%;
					flex: 1;
					object-fit: contain;
					margin-top: 30px;
				}
				.header-titles {
					flex: 1;
					margin-left: 0;
					padding: 0;
					.title {
						font-size: 2.5rem;
					}
					.sub-title {
						font-size: 1rem;
						line-height: 1.5rem;
						color: ${colors.textDark};
					}
				}
			}
			.apply-now {
				width: 100%;
			}
		}
	}
`;
